import actions from './actions';
import getters from './getters'
import mutations from './mutations';


const getDefaultState = () => ({
  mode : 'tile',
  salesOrders : [],
  selectedSalesOrder : {
    billingAddress : null,
    billingContact : null,
    createdAt : null,
    createdBy : null,
    credit : 0,
    customer : null,
    date : null,
    deliveryFee: null,
    deliveryType : null,
    expectedDeliveryDate : null,
    extraInfo : null,
    id : null,
    invalid : null,
    invoicedAt : null,
    invoices : [],
    lines : [],
    notes : '',
    packages : [],
    reference : '',
    rep : null,
    shippingAddress : null,
    shippingAontact : null,
    soNumber : null,
    status : null,
    statusLogs : [],
    subTotal : 0,
    tags : [],
    taxes : [],
    total : 0,
    updatedAt : null,
    updatedBy : null,
    subTotalBillable: null,
  },
  selectedSalesOrderHistoricActivities : [],
  selectedIndex : null,
  orderBy:{orderName : 'created_at',  direction:'DESC'},
  outDated : true,
  loading : false,
  salesOrderLoading: false,
  searchTerms :'',
  sort_icon : 'el-icon-caret-bottom',
  icons : {
    'DESC' : 'el-icon-caret-bottom',
    'ASC' : 'el-icon-caret-top'
  },
  page : 1,
  pages : 0, //nombre de page total
  count : 0,
  limit : 50,
  reportDownloading: false,
  filters : {
    status : [],
    date : null,
    deliveryDate: null,
    checkedCustomerClasses : [],
    checkedTags : [],
    checkedReps : [],
    withoutReps : false,
    customerId : null,
    productId : null,
    deliveryType : [],
    inventories: [],
    origin: [],
  }
});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
